//REACT
import React from 'react'
//Secciones
import Cabecera from "../CabeceraPie/Cabecera"
import PiePagina from "../CabeceraPie/PiePagina"

import Carrusel from "pages/Home/sections/Carrusel"
import NavPills from "components/NavPills/NavPills"
// core components
import GridContainer from "components/Grid/GridContainer.js"
import GridItem from "components/Grid/GridItem.js"
import Card from "components/Card/Card.js"
import { ContactSupport, HeadsetMic } from '@material-ui/icons';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
//import { stockData } from "./preguntasFrecuentes";
var stockData = require("./preguntasFrecuentes.json");
export default function IndexHome() {
  const [expanded, setExpanded] = React.useState(false);
  const [preguntasR, setPreguntasR] = React.useState([]);
  React.useEffect(() => {
    window.localStorage.clear()
    window.sessionStorage.clear()
  });
  React.useEffect(() => {
    setPreguntasR(stockData)
  }, [stockData]);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  }
  return (
    <div>
      <Cabecera color="transparent" />
      <Carrusel />
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={6}>
          <NavPills
            alignCenter
            color="primary"
            tabs={[
              {
                tabButton: "Atención Comercial",
                tabIcon: SupervisorAccountIcon,
                tabContent: (
                  <Card style={{ padding: "20px" }}>
                    <span>
                      <p>
                        Uno de los pilares fundamentales de nuestra empresa es la atención hacia nuestros clientes, por lo que contamos con un personal
                        capacitado que le proporcionará toda la información necesaria en el proceso de compra de nuestros productos.
                      </p>
                      <p>
                        No dude en contactarnos, será bien atendido.
                      </p>
                      <br></br>
                      <p>                        
                        Email: contacto@firmadox.cl
                      </p>
                      <br></br>
                      <p>
                        Teléfono: +56232230152
                      </p>
                    </span>
                  </Card>
                )
              },
              {
                tabButton: "SOPORTE",
                tabIcon: HeadsetMic,
                tabContent: (
                  <Card style={{ padding: "20px" }}>
                    <span>
                      <p>
                      Si necesita ayuda con el uso de los productos que entrega FirmaDOX, no dude en contactarnos en los siguientes canales:
                      </p>
                      <p>
                      
                      </p>
                      <br></br>
                      <p>                        
                        Email: soporte@firmadox.cl
                      </p>
                      <br></br>
                      <p>
                        Teléfono: +56226179201
                      </p>
                    </span>
                  </Card>
                )
              },
              {
                tabButton: "Preguntas Frecuentes",
                tabIcon: ContactSupport,
                tabContent: (
                  <div style={{ padding: "20px" }}>
                    {preguntasR && preguntasR.map((questionProp, key) =>
                      <ExpansionPanel expanded={expanded === key} onChange={handleChange(key)}>
                        <ExpansionPanelSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1bh-content"
                          id="panel1bh-header"
                        >
                          <Typography sx={{ width: '33%', flexShrink: 0 }} variant="caption text">
                            {questionProp.pregunta}
                          </Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                          <Typography variant="caption text">
                            {questionProp.respuesta}
                          </Typography>
                        </ExpansionPanelDetails>
                      </ExpansionPanel>
                    )}
                  </div>
                )
              }
            ]}
          />
        </GridItem>
      </GridContainer>
      <PiePagina />
    </div>
  )
}